export default "__VITE_ASSET__ailqZDrr__"